import "./SpineSurgery.module.css";
import Header from "@/reusable_sections/Header";
import ProfessionalHero from "../Treatments/sections/ProfessionalHero";
import FiveWeekCourseDetails from "../Treatments/sections/FiveWeekCourseDetails";
import TransparentPricing from "../Treatments/sections/TransparentPricing";
import Footer from "@/reusable_sections/Footer";
export default function SpineSurgeryPage() {
  return <div>
      <Header />
      <ProfessionalHero />
      <FiveWeekCourseDetails />
      <TransparentPricing />
      <Footer />
    </div>;
}